import Controller from "../Controller";
import {Benefit, BenefitPayload} from "../../models/Benefit";

class Benefits extends Controller {
  public getAll = async (): Promise<Benefit[]> => {
    const data = await this.get("/benefits");

    return this.parseArray<Benefit>(Benefit, data["benefits"]);
  };

  public getById = async (id: string): Promise<Benefit> => {
    const data = await this.get("/benefits/"+encodeURIComponent(id));

    return this.parse(Benefit, data);
  };

  public deleteBenefit = async (id: string): Promise<void> => {
    const endpoint = "/benefits/"+encodeURIComponent(id);
    const data = await this.delete(endpoint);

    if (data && data.employee_ids) {
      throw { employeeIds: data.employee_ids as string[] };
    }
  };

  private mapValues = (values: BenefitPayload) => {
    return {
      price: values.price.value,
      family: values.family,
      active: values.isActive,
      package: values.packageName,
      baseBenefit: values.baseBenefit
    }
  };

  public putBenefit = async (id: string, values: Benefit): Promise<Benefit> => {
    const mapped = this.mapValues(values);
    const data = await this.put("/benefits/"+encodeURIComponent(id), mapped);

    if (data && data.employee_ids) {
      throw { employeeIds: data.employee_ids as string[] };
    }

    return this.parse(Benefit, data);
  }

  public addBenefit = async (values: BenefitPayload): Promise<Benefit> => {
    const mapped = this.mapValues(values);
    const data = await this.post("/benefits", mapped);

    return this.parse(Benefit, data);
  }
}

const benefits = new Benefits("");

export default benefits;
